export default "__VITE_ASSET__B8FpjG5s__"